import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { CustomerIdDropDownComponent } from './customer-id-drop-down.component';

@NgModule({
  imports: [CommonModule, PageSlotModule, I18nModule, FormsModule, KbPipesModule],
  exports: [CustomerIdDropDownComponent],
  declarations: [CustomerIdDropDownComponent],
  providers: [],
})
export class KbCustomerIdDropdownModule {}
